export class ScreenTemplate {
    name = null;
    code = null;
    staff = null;
    listTemplate = null;
}

export class ConceptTemplate {
    screen = null;
    concept = null;
    value = null;
    clientCode = null;
    staff = null;
}